module.exports = __webpack_public_path__ + "img/1.79ea629e.jpg";